import { useState } from 'react';

export const useMenu = () => {
  const [isMenuOpen, setMenuIsOpen] = useState(false);
  const openMenu = () => setMenuIsOpen(true);
  const closeMenu = () => setMenuIsOpen(false);

  return {
    isMenuOpen,
    openMenu,
    closeMenu,
  };
};
